import { render, staticRenderFns } from "./multiDialogNotes.vue?vue&type=template&id=77d0f88a&"
import script from "./multiDialogNotes.vue?vue&type=script&lang=js&"
export * from "./multiDialogNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports